import { Analytics } from './analytics';
import { ItemSearchAction } from '../../../search/itemSearch/actions/item_search_action';

export class ItemSearchAnalytics extends Analytics {
  constructor() {
    super();
    ItemSearchAction.ITEM_SEARCH_MODAL_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'クリック_商品詳細_モーダル_類似品を探す',
          soloel: {
            server: 'soloel/pc',
            prop5: 'クリック_商品詳細_モーダル_類似品を探す',
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'クリック_商品詳細_モーダル_類似品を探す');
      });
    });
  }
}
